import { type FC } from 'react';

import { useTimerToEnd } from '@/common/hooks/timer-to-end';
import { timeStringFormatShortForm } from '@/common/lib/timer';

interface TimerProps {
  expiredAt: string;
}

const Timer: FC<TimerProps> = ({ expiredAt }) => {
  const time = useTimerToEnd(expiredAt);

  return (
    <div className="rounded-b-lg mb-4 bg-white/20 backdrop-blur-[32x] px-4 py-1">
      <span className="text-white leading-1.2 text-[1.5rem] font-bold whitespace-nowrap">
        {timeStringFormatShortForm((time || 0) * 1000, true)}
      </span>
    </div>
  );
};

export { Timer };
